import left from './left'
import right from './right'
import down from './down'
import rotate from './rotate'
import space from './space'
import s from './s'
import r from './r'
import p from './p'
import x from './x'

export default {
  left,
  down,
  rotate,
  right,
  space,
  r,
  p,
  s,
  x
}



// WEBPACK FOOTER //
// ./src/control/todo/index.js